import React, { Fragment, useEffect, useState } from 'react';
import "./ImportContent.css"
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { BASE_URL } from '../../constants/constants';
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import fr from 'date-fns/locale/fr';
import { getLastTransmissionDate } from '../../services/http';
import ProcessSpinner from '../ProcessSpinner/ProcessSpinner';



const ImportContent = (props) => {

    const {processOngoing, handleImportData, type, downloadRequest, fileName} = props;

    const dispatch = useDispatch();
    const states = useSelector((state) => state, shallowEqual);
    registerLocale('fr', fr)

    const [transmissionDate, setTransmissionDate] = useState(new Date());
    const [lastDateTransmission, setLastDateTransmission] = useState("")


    useEffect(() => {   
   
        return  () => {
            dispatch({
                type: "SET",
                key: "selectedFile",
                payload: null
        });
        }
    }, []);

    const handleFileChoose = (e) => {
        const value = e.currentTarget.files[0]
        console.log("value ", value)
        dispatch({
                type: "SET",
                key: "selectedFile",
                payload: value
        });
}

const downloadSample = async () => {
   const response = await downloadRequest(states.userToken.access_token);
   console.log(response)
   const url = window.URL.createObjectURL(new Blob([response.data]));
   const link = document.createElement('a');
   link.href = url;
   link.setAttribute('download', fileName + '.xlsx'); 
   document.body.appendChild(link);
   link.click();
}

useEffect(() => {
  if(fileName == "taux") {
    dispatch({
        type: "SET",
        key: "importTransmissionDate",
        payload: {"month" : transmissionDate.getMonth()+1, "year": transmissionDate.getFullYear()}
});
  }
}, [transmissionDate])


const loadLastDateTransmission = async () => {
        const response = await getLastTransmissionDate(states.userToken.access_token)
        if (response.response && response.response.status !== 200) {
            console.log("last Date of transmission error ", response.response)
        } else {
            console.log("Last date of transmission data ", response.data) 

            if(response.data == "") {
                setLastDateTransmission("01/01/2000")
                console.log(lastDateTransmission)
            } else {
                var splitResponse = response.data.split("-")
                var reconstructedResponse = splitResponse[1] + "/" + splitResponse[0]
                setLastDateTransmission(new Date(`${splitResponse[1]}/10/${splitResponse[0]}`))
    
                // setLastDateTransmission(reconstructedResponse)
                console.log(`${splitResponse[1]}/10/${splitResponse[0]}`)
            }

            
        }
    }

    useEffect(() => {
            loadLastDateTransmission();
    }, [])



    return (
        <Fragment>
               <div className="row my-2 text-left">
                                <h3 className="mb-2 bold py-2 pl-3">Importer des {type} </h3>
                        </div>
            <div className="widget widget-content widget-content-area br-6 mb-3 p-3 text-left">
                <h5 className="mb-2 bold"> 1. Télécharger et remplir le modèle</h5>
                <p className="">L'importation des {type} se fait via un fichier excel. Il vous suffit donc de remplir votre fichier excel en suivant le format recommandé. Vous pouvez télécharger un modèle en cliquant sur le bouton ci-dessous.
                </p>

                <button className="btn btn-dark mb-3" onClick={downloadSample}>Télécharger le modèle exemple</button>

            </div>
            <div className=" widget widget-content widget-content-area br-6 p-3 text-left">
                <h5 className="mb-2 bold text-left">2. Importer vos {type} via votre excel</h5>
                <p className="text-left">Vous avez à présent un fichier excel contenant vos {type} au format recommandé. Vous pouvez les importer en chargeant votre fichier dans le champ ci-dessous.
                </p>

                <br />
                    {fileName == "taux" && 
                    <p className="d-flex flex-nowrap text-center "><div className="pt-1">Transmission de :  </div><div className="ml-2">
                    <DatePicker
                        selected={transmissionDate}
                        onChange={(date) => setTransmissionDate(date)}
                        dateFormat="MM/yyyy"
                        locale="fr"
                        minDate={new Date(lastDateTransmission)}
                        // minDate={lastDateTransmission}
                        maxDate={new Date()}
                        placeholderText="Cliquez"
                        showMonthYearPicker
                        showFullMonthYearPicker
                        className="form-control custom-form-control basic mb-3 w-50"
                    />
                </div> </p>
                    }
                <div className=" d-flex justify-content-between flex-wrap ">
                    <div className="text-left mb-3 w-50">
                        <div className="custom-file">
                            <input type="file" onChange={(e) => handleFileChoose(e)} className="custom-form-control custom-file-input" id="customFile" />
                            <label class="custom-file-label" for="customFile">{(states.selectedFile?.name != null) ? states.selectedFile.name : "Aucun fichier"}</label>
                        </div>
                    </div>

                    <div className="text-right mb-3">
                       {
                       processOngoing == false ? <button className="btn btn-dark" onClick={handleImportData}>Importer les {type} </button>
                       : <ProcessSpinner />
                       }
                    </div>
                </div>

            </div>
        </Fragment>
    )
}

export default ImportContent